import { Link } from 'react-router-dom';
import { articles } from '@/mocks/gallery';

export default function LatestUpdates() {
  const latest = articles.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-900 mb-3">
            最新更新
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            每日更新的美女写真作品，新鲜出炉的热门美图等你来发现
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latest.map((article) => {
            const category = article.category;
            return (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group relative rounded-xl overflow-hidden aspect-[4/5] cursor-pointer border border-background-200/70"
              >
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/15 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-3 py-1 text-xs font-medium bg-accent-500 text-white rounded-full">
                    {category === 'qingchun' ? '清纯系' :
                     category === 'qizhi' ? '气质系' :
                     category === 'shishang' ? '时尚系' :
                     category === 'xinggan' ? '性感系' :
                     category === 'gufeng' ? '古风系' : '日系'}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                  <h3 className="text-base md:text-lg font-bold font-heading text-white mb-2 line-clamp-2">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-4 text-xs text-white/70">
                    <span>{article.date}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views > 9999 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-heart-line"></i>
                      {article.likes}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}